/** Renders authored line breaks (content arrays) as block spans; screen readers read one sentence. */
export function Lines({ lines }: { lines: readonly string[] }) {
  return <>{lines.map((line, index) => <span key={index} className="line">{line}{index < lines.length - 1 ? ' ' : ''}</span>)}</>;
}
